import { isTruthyTinyInt } from './parametre-doc-api-normalize';

/** true = matrice couleur × taille ; false = une ligne par variante (classique). */
export function resolveDocumentProductMatrixDisplay(options: {
  stationAffProduitMatriciel?: unknown;
  sessionAfficherProduitsMatriciel?: unknown;
}): boolean {
  const session = options.sessionAfficherProduitsMatriciel;
  if (session !== undefined && session !== null) {
    return isTruthyTinyInt(session);
  }
  const station = options.stationAffProduitMatriciel;
  if (station !== undefined && station !== null) {
    return isTruthyTinyInt(station);
  }
  return true;
}
